import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=3892e2a2"
import script from "./maintenance.vue?vue&type=script&lang=ts"
export * from "./maintenance.vue?vue&type=script&lang=ts"
import style0 from "./maintenance.vue?vue&type=style&index=0&id=3892e2a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
